import React from 'react'
import SvgChevronRight from 'src/components/Svgs/SvgChevronRight'

interface AnimatedTableChevronProps {
  className?: string
  fill?: string
}

const AnimatedTableChevron: React.FC<AnimatedTableChevronProps> = (
  props,
): React.ReactElement => {
  return (
    <SvgChevronRight
      className={props.className ?? 'animated-table-chevron'}
      fill={props.fill}
      data-testid={'animated-chevron'}
    />
  )
}

export default AnimatedTableChevron
